var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8001 13.3325C8.15836 13.3325 5.80909 14.608 4.31342 16.5875C3.99151 17.0135 3.83055 17.2265 3.83582 17.5144C3.83989 17.7368 3.97955 18.0174 4.15456 18.1548C4.38108 18.3325 4.69498 18.3325 5.32278 18.3325H16.2774C16.9052 18.3325 17.2191 18.3325 17.4456 18.1548C17.6206 18.0174 17.7603 17.7368 17.7644 17.5144C17.7696 17.2265 17.6087 17.0135 17.2868 16.5875C15.7911 14.608 13.4418 13.3325 10.8001 13.3325Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8001 10.8325C12.8712 10.8325 14.5501 9.15359 14.5501 7.08252C14.5501 5.01145 12.8712 3.33252 10.8001 3.33252C8.72902 3.33252 7.05009 5.01145 7.05009 7.08252C7.05009 9.15359 8.72902 10.8325 10.8001 10.8325Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d81f1a84b57541da0eb2e18cae276b4b.svg";
export { ForwardRef as ReactComponent };